import { z } from 'zod/v4'
import { FileTypeValidator } from './GridFileTypes'

export const FileProcessingWorkflowParamsValidator = z.object({
    gridVersionId: z.string(),
    fileName: z.string(),
    fileType: FileTypeValidator,
})
export type FileProcessingWorkflowParams = z.infer<typeof FileProcessingWorkflowParamsValidator>

export const FileStatusValidator = z.object({
    fileName: z.string(),
    fileType: FileTypeValidator,
    status: z.enum(['pending', 'processing', 'completed', 'failed']),
    chunksTotal: z.number().optional(),
    chunksProcessed: z.number().optional(),
    error: z.string().optional(),
    startTime: z.number().optional(),
    completedTime: z.number().optional(),
})
export type FileStatus = z.infer<typeof FileStatusValidator>

export const DataChunkValidator = z.array(z.record(z.string(), z.any()))
export type DataChunk = z.infer<typeof DataChunkValidator>

export const SendVerificationCodeParamsValidator = z.object({
  email: z.string(),
  code: z.string(),
})
export type SendVerificationCodeParams = z.infer<typeof SendVerificationCodeParamsValidator>
